import {Inject, ModelEvents, GameRandom, Singleton} from "@denishussar/html5-game-engine";
import { CameraConstants } from "../Constants/CameraConstants";
import { DifficultyConstants } from "../Constants/DifficultyConstants";
import { IFieldSize, FieldSizesConstants } from "../Constants/FieldSizesConstants";
import { FieldTypeConstants } from "../Constants/FieldTypeConstants";
import KykkaSizeConstants from "../Constants/KykkaSizeConstants";
import { PlayerTurnConstant } from "../Constants/PlayerTurnConstant";
import { PlayerTypeConstants } from "../Constants/PlayerTypeConstants";
import { LocalizationContents } from "../LocalizationContents";
import { CameraModel } from "./CameraModel";
import { KykkaModel} from './KykkaModel' ;
import { PlayerModel } from './PlayerModel' ;

export enum GameModalsEnum {
    none = 0,
    pause = 1,
    record = 2,
    settings = 3,
    exitGame = 4,
    exitMenu = 5,
    connectionError = 6,
    help = 7,
    charSelect = 8,
    win = 9,
    lose = 10,
}

export interface IScoreLogItem {
    city: number,
    edge: number,
    line: number,
    total: number,
    delta: number,
    player: PlayerTurnConstant
}
export interface RecordsTable {
    [FieldTypeConstants.Small]: number,
    [FieldTypeConstants.Medium]: number,
    [FieldTypeConstants.Big]: number
}

export interface DropDownScoreLog {
    list: IScoreLogItem[],
    complete: boolean
}

@Singleton
export class GameModel {
    public scoreA: number = 0;
    public scoreB: number = 0;
    public readonly maxHit = 12;
    public hitLeftCounterA = this.maxHit; // TODO: remove
    public hitLeftCounterB = this.maxHit; // TODO: remove
    public hitCounter: number = 0;
    public fieldType: FieldTypeConstants = FieldTypeConstants.Medium


    public cameraIndex: CameraConstants = CameraConstants.MediumAway;
    //public camera: CameraModel = new CameraModel();
    public fieldSize: IFieldSize = FieldSizesConstants[0];

    public gameOver: boolean = true;
    public showGameEnd: boolean = false;
    public showLeaderboard: boolean = false;
    public showIntro: boolean = true;
    public showMiniGame: boolean = false;
    public showMainMenuContainer: boolean = false;
    public showMainMenu: boolean = true;
    public showPopupShading: boolean = true;
    public showTutorial: boolean = false;
    public showPlayController: boolean = false;
    public showSpecialWindow: boolean = false;
    public showGame: boolean = false;
    public isGameReady: boolean = false; // true, когда выставлены все настройки - выбран персоонаж, тип поля, чей первый ход и т.п.
    public isFreeField: boolean = true; // true, когда все кюки очищены и счет
    public roundNumber: number = 0;

    public tutorialWasShow: boolean = false;

    public playerA: PlayerModel; // игрок
    public playerB: PlayerModel; // бот
    public firstPlayer: PlayerModel; // кто ходит первым. Сылка на playerA или playerB

    public pause: boolean = false;

    public modalState: GameModalsEnum = GameModalsEnum.none;

    public isMusicOn = true;
    public isSoundsOn = true;

    //Kykka Items
    public kykkaItems: KykkaModel[] = []; //TODO: рзарефакторить как kykkaItemsA
    public kykkaItemsB: KykkaModel[] = []; // кюки бота

    public scoresLog: DropDownScoreLog[] = [];

    public lang: string = LocalizationContents.getUserLanguage();

    public currentTurn: PlayerTurnConstant = PlayerTurnConstant.A;
    public records: RecordsTable = {
        [FieldTypeConstants.Small]: 0,
        [FieldTypeConstants.Medium]: 0,
        [FieldTypeConstants.Big]: 0
    };

    constructor(@Inject private _$random:GameRandom,
                @Inject private _$modelEvents:ModelEvents){

        this.playerA = new PlayerModel(PlayerTypeConstants.Kid);
        this.playerB = new PlayerModel(PlayerTypeConstants.Woman);


    }

    public endGame() {
        this.gameOver = true;
    }

    public newGame() {
        this.fieldSize = FieldSizesConstants[this.fieldType];
        this.playerA.roundsScoresLog = [];
        this.playerB.roundsScoresLog = [];
        this.scoresLog = [];
        this.gameOver = false;
        this.newRound();
        this.roundNumber = 0;
    }

    public newRound() {
        this.isFreeField = false;
        this.playerA.z3d = this.fieldSize.length + this.fieldSize.distance;
        this.playerB.z3d = this.fieldSize.length + this.fieldSize.distance;
        this.playerA.scoresLog = [];
        this.playerB.scoresLog = [];
        this.playerA.hits = 0;
        this.playerB.hits = 0;
        this.playerA.kykkaTouched = false;
        this.playerB.kykkaTouched = false;
        this.scoresLog.unshift({
            list: [],
            complete: false
        });

        const kykkaAmount = 20;

        this.kykkaItems = [
            ...this._generateKykkas(kykkaAmount, 0),
            // ...this._generateKykkas(kykkaAmount, -4000)
        ];

        this.kykkaItemsB = [
            ...this._generateKykkas(kykkaAmount, this.fieldSize.distance),
            // ...this._generateKykkas(kykkaAmount, this.fieldSize.distance +4000)
        ];
    }

    private _generateKykkas(kykkaAmount, z) {
        const w = this.fieldSize.width - 500;
        const delta = w / (0.5 * kykkaAmount + 1);
        let x = -0.5 * w;
        let y = 0;
        const kykkaItems = [];
        for (let i = 0; i < kykkaAmount; i++) {
            if (i % 2 === 0) {
                x += delta;
                y = 0.5 * KykkaSizeConstants.height;
            } else {
                y = 1.5 * KykkaSizeConstants.height;
            }
            // if(i===0) {
            //     x = -0.5 * (this.fieldSize.width);
            // } else if(i===1) {
            //     x = 0.5 * (this.fieldSize.width);
            // }
            const k = new KykkaModel(x, y, z);
            kykkaItems.push(k);
            this.scoreA -= 2;
            this.scoreB -= 2;
        }
        return kykkaItems;
    }
}

